import * as React from 'react';
import { Form } from '../';
import FIELDS from '../../data/fields';
import { actions } from 'react-redux-form';

interface Props {
  vehicle: IVehicle;
  onSubmit: (data) => void;
  disabled?: boolean;
}

const ServiceVehicleForm = ({ vehicle, onSubmit, disabled }: Props) => (
  <Form
    fields={FIELDS.vehicles.service}
    type="service"
    handleSubmit={onSubmit}
    disabled={disabled}
    getDispatch={(dispatch) => {
      dispatch(actions.change('service.mileage', vehicle.mileage));
    }}
    values={{
      type: [
        {
          name: 'Check Over',
          value: 'CHECK_OVER',
        },
        {
          name: 'Full Service',
          value: 'FULL',
        },
        {
          name: 'Interim',
          value: 'INTERIM',
        },
      ],
    }}
  />
);

export default ServiceVehicleForm;
